module.exports = __webpack_public_path__ + "img/空.f51befc0.png";